import React from 'react'
import { SvgIcon } from '@mui/material'

export default props => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path d="M13.3 12.22a4.92 4.92 0 0 0 .24-7.26 5 5 0 0 0-8.1 5.58c.3.65.73 1.22 1.26 1.68A8 8 0 0 0 2 19.5a1 1 0 1 0 2 0 6 6 0 1 1 12 0 1 1 0 0 0 2 0 8 8 0 0 0-4.7-7.28ZM10 11.5a3 3 0 1 1 0-6 3 3 0 0 1 0 6Zm10.91.5.8-.79a1 1 0 0 0-1.42-1.42l-.79.8-.79-.8a1 1 0 1 0-1.42 1.42l.8.79-.8.79a1 1 0 1 0 1.42 1.42l.79-.8.79.8a1 1 0 1 0 1.42-1.42l-.8-.79Z" />
  </SvgIcon>
)
